//export const API_BASE = 'http://localhost:5000/api'; // change for prod
// export const API_BASE = 'https://198.199.74.30:5000'; // change for prod
export const API_BASE = 'https://backend.drilling-materials.com/api'; // change for prod